export class ContactServerMaillist {
    constructor(ctx) {
        this.ctx = ctx;
    }
    async operateMailLsit(params) {
        var _a, _b, _c;
        try {
            const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('operateMailList'), params, {
                contentType: 'json',
            });
            const list = (data === null || data === void 0 ? void 0 : data.data) ? (_a = data.data) === null || _a === void 0 ? void 0 : _a.contactVO : undefined;
            console.log('[contact_server] operateMailLsit', list);
            if (list) {
                const syncData = await this.ctx.contactDB.enterpriseAllInto({
                    list: [list],
                    _account: ((_b = this.ctx.systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.id) || '',
                });
                let notify = {
                    syncStatus: { enterprise: true },
                    _account: ((_c = this.ctx.systemApi.getCurrentUser()) === null || _c === void 0 ? void 0 : _c.id) || '',
                };
                syncData.forEach(item => {
                    notify = Object.assign(Object.assign({}, notify), item);
                });
                this.ctx.contactDB.sendContactNotify(notify);
            }
        }
        catch (e) {
            console.error('[contact_server] operateMailLsit error', e);
        }
    }
    async getMaillistMember(accountName) {
        var _a;
        try {
            const { account, domain } = this.ctx.contactUtil.handleAccountAndDomain(accountName);
            const { data } = await this.ctx.http.get(this.ctx.systemApi.getUrl('getMaillistMember'), {
                account_name: account,
                domain: domain || this.ctx.contactUtil.getDomain(),
                dynamic_spread: 1,
            }, {
                _account: ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '',
                headers: {
                    'Qiye-Header': 'anticsrf',
                },
            });
            if (!(data === null || data === void 0 ? void 0 : data.result)) {
                return {
                    success: false,
                    message: data === null || data === void 0 ? void 0 : data.error,
                    errorCode: data === null || data === void 0 ? void 0 : data.errorCode,
                };
            }
            return (data === null || data === void 0 ? void 0 : data.result) || [];
        }
        catch (e) {
            console.error('[contact_server] getMaillistMember error', e);
            return {
                success: false,
            };
        }
    }
    async createMaillist(mailListMember) {
        try {
            const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('createMaillist'), mailListMember, {
                headers: { 'Qiye-Header': 'qiye' },
                contentType: 'json',
            });
            const { code, result, error, errorCode } = data;
            if (code !== 200 || !result) {
                return {
                    success: false,
                    message: error,
                    errorCode,
                };
            }
            return {
                success: true,
                data: (data === null || data === void 0 ? void 0 : data.result) || {},
            };
        }
        catch (e) {
            console.error('[contact_server] createMaillist error', e);
            return {
                success: false,
            };
        }
    }
    async updateMaillist(mailListMember) {
        try {
            const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('updateMaillist'), Object.assign({}, mailListMember), {
                headers: { 'Qiye-Header': 'qiye' },
                contentType: 'json',
            });
            const { code, result, error, errorCode } = data;
            if (code !== 200 || !result) {
                return {
                    success: false,
                    message: error,
                    errorCode,
                };
            }
            return {
                success: true,
                data: (data === null || data === void 0 ? void 0 : data.result) || {},
            };
        }
        catch (e) {
            console.error('[contact_server] getMaillistMember error', e);
            return {
                success: false,
            };
        }
    }
    async deleteMaillist(delMailListParams) {
        try {
            const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('deleteMaillist'), Object.assign({}, delMailListParams), {
                headers: { 'Qiye-Header': 'qiye' },
                contentType: 'json',
            });
            const { code, result, error, errorCode } = data;
            if (code !== 200 || !result) {
                return {
                    success: false,
                    message: error,
                    errorCode,
                    code,
                };
            }
            return {
                success: true,
                data: (data === null || data === void 0 ? void 0 : data.result) || {},
            };
        }
        catch (e) {
            console.error('[contact_server] getMaillistMember error', e);
            return {
                success: false,
            };
        }
    }
    async listUserDomain() {
        try {
            const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('listUserDomain'), {}, { headers: { 'Qiye-Header': 'qiye' } });
            return data;
        }
        catch (e) {
            console.error('[contact_server] getMaillistMember error', e);
            return {
                success: false,
            };
        }
    }
    async listUserMaillist(type) {
        var _a;
        try {
            const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('listUserMaillist'), type ? { maintainer_type: type } : {}, {
                headers: { 'Qiye-Header': 'qiye' },
                contentType: 'json',
            });
            const { code, result, error } = data;
            if (code !== 200 || !result) {
                return {
                    success: false,
                    message: error,
                };
            }
            return {
                success: true,
                data: ((_a = data === null || data === void 0 ? void 0 : data.result) === null || _a === void 0 ? void 0 : _a.data) || [],
            };
        }
        catch (e) {
            console.error('[contact_server] listUserMaillist error', e);
            return {
                success: false,
            };
        }
    }
    async getMaillist(getMailListParams) {
        try {
            const { data } = await this.ctx.http.get(this.ctx.systemApi.getUrl('getMaillist'), Object.assign({}, getMailListParams), {
                headers: { 'Qiye-Header': 'qiye' },
                contentType: 'json',
            });
            const { code, result, error, errorCode } = data;
            if (code !== 200 || !result) {
                return {
                    success: false,
                    message: error,
                    errorCode,
                };
            }
            return {
                success: true,
                data: (data === null || data === void 0 ? void 0 : data.result) || {},
            };
        }
        catch (e) {
            console.error('[contact_server] getMaillistMember error', e);
            return {
                success: false,
            };
        }
    }
    async getMaillistConfig() {
        try {
            const { data } = await this.ctx.http.get(this.ctx.systemApi.getUrl('getMaillistConfig'), {}, {
                headers: { 'Qiye-Header': 'qiye' },
                contentType: 'json',
            });
            const { code, result, error, errorCode } = data;
            if (code !== 200 || !result) {
                return {
                    success: false,
                    message: error,
                    errorCode,
                };
            }
            return {
                success: true,
                data: (data === null || data === void 0 ? void 0 : data.result) || {},
            };
        }
        catch (e) {
            console.error('[contact_server] getMaillistMember error', e);
            return {
                success: false,
            };
        }
    }
    async checkMaillistAccountName(mailListMember) {
        try {
            const { data } = await this.ctx.http.post(this.ctx.systemApi.getUrl('checkMaillistAccountName'), Object.assign({}, mailListMember), {
                headers: { 'Qiye-Header': 'qiye' },
                contentType: 'json',
            });
            const { code, result, error, errorCode } = data;
            if (code !== 200 || !result) {
                return {
                    success: false,
                    message: error,
                    errorCode,
                };
            }
            return {
                success: true,
                data: (data === null || data === void 0 ? void 0 : data.result) || {},
            };
        }
        catch (e) {
            console.error('[contact_server] getMaillistMember error', e);
            return {
                success: false,
            };
        }
    }
}
